<section id="rebrandedTestimonialsSection" class="font-noto tw-my-2 tw-pb-2" [class.tw-pt-5]="!decreaseHeaderGap()">
  <div class="tw-flex tw-items-center tw-justify-start tw-pl-4 tw-mb-3">
    <div class="tw-font-bold tw-text-600 tw-text-gray-800 tw-text-center" i18n="@@ourUserStories"> Our user stories </div>
  </div>
  <swiper class="tw-w-full tw-overflow-visible" #swiper="" [config]="swiperConfig" (slideChange)="onSlideChange()">
    @for (testimonial of testimonials(); track $index; let i = $index) {
      <div class="tw-bg-white tw-ml-4 tw-shadow-[0px_8px_30px_0px_#0000001A] tw-rounded-4" *swiperSlide
           [style.height.px]="isExpanded(i) ? null : collapsedCardHeightPx">
        <div id="testimonial-header" class="tw-relative tw-w-full">
          <img class="tw-rounded-tl-4 tw-rounded-tr-4 tw-w-full tw-h-[150px] sm:tw-h-[175px] tw-object-cover" [src]="testimonial['testimonialImg']" alt="user_improvement"/>
          <p class="tw-absolute tw-top-4 tw-left-5 tw-text-white tw-text-200 tw-font-bold" i18n="@@before">Before</p>
          <p class="tw-absolute tw-top-4 tw-right-5 tw-text-white tw-text-200 tw-font-bold" i18n="@@after">After</p>
        </div>
        <div id="testimonial-content" class="tw-pt-4 tw-pr-5 tw-pb-4 tw-pl-5">
          <div class="tw-flex tw-items-center tw-gap-2">
            @if (testimonial['userImg']) {
              <img [src]="testimonial['userImg']" class="tw-w-8 tw-h-8 tw-rounded-full" alt="user_profile"/>
            } @else {
              <div class="tw-w-8 tw-h-8 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-text-white tw-font-bold tw-text-300"
                   [class]="avatarBgClass(i)">{{ avatarInitial(testimonial['name']) }}</div>
            }
            <span class="tw-flex tw-flex-wrap tw-items-center">
              <p class="tw-text-200 tw-text-gray-800 tw-font-bold"> {{testimonial['name']}} </p>&#44;&nbsp;<p class="tw-text-200 tw-italic">{{testimonial['location']}} {{testimonial['occupation']}}</p>
            </span>
          </div>
          <div class="tw-relative tw-mt-1 tw-pt-2.5 tw-pb-2.5">
            <p class="tw-text-200 tw-text-gray-500 tw-break-words"
               [class.tw-line-clamp-4]="!isExpanded(i) && isTruncatable(testimonial['testimonial'])">{{testimonial['testimonial']}}@if (isTruncatable(testimonial['testimonial']) && isExpanded(i)) {&nbsp;<span class="tw-font-bold tw-text-teal-600 tw-cursor-pointer" (click)="toggleExpanded(i)" i18n="@@readLess">Read Less</span>}</p>
            @if (isTruncatable(testimonial['testimonial']) && !isExpanded(i)) {
              <span class="tw-absolute tw-bottom-2.5 tw-right-0 tw-pl-10 tw-text-200 tw-bg-gradient-to-r tw-from-transparent tw-to-white"
                    (click)="toggleExpanded(i)">
                <span class="tw-bg-white tw-font-bold tw-text-teal-600 tw-pb-1 tw-pr-1">…&nbsp;<ng-container i18n="@@readMore">Read More</ng-container></span>
              </span>
            }
          </div>
          <p class="tw-text-200 tw-font-500 tw-text-gray-800 tw-mt-2.5" i18n="@@effectivelyReduced">Effectively Reduced:</p>
          @if (testimonial.tags.length !== 3) {
            <div class="tw-flex tw-flex-wrap tw-gap-y-2 tw-gap-x-1.5 tw-mt-2 tw-text-gray-800">
              @for (tag of testimonial.tags; track $index) {
                <p class="tw-bg-teal-100 tw-text-200 tw-w-max tw-px-3 tw-py-1 tw-rounded-5 tw-text-gray-800">{{tag}}</p>
              }
            </div>
          }
          @if (testimonial.tags.length === 3) {
            <div class="tw-flex tw-flex-wrap tw-gap-y-2 tw-gap-x-1.5 tw-mt-2 tw-text-gray-800">
              <p class="tw-bg-teal-100 tw-text-200 tw-w-max tw-px-3 tw-py-1 tw-rounded-5 tw-text-gray-800">{{testimonial.tags[0]}}</p>
              <p class="tw-bg-teal-100 tw-text-200 tw-w-max tw-px-3 tw-py-1 tw-rounded-5 tw-text-gray-800">{{testimonial.tags[1]}}</p>
            </div>
            <p class="tw-bg-teal-100 tw-text-200 tw-w-max tw-px-3 tw-py-1 tw-rounded-5 tw-text-gray-800 tw-mt-2">{{testimonial.tags[2]}}</p>
          }
        </div>
      </div>
    }
  </swiper>
</section>
